import Container from '@material-ui/core/Container';

import FillForm from './FillForm';


const FirstForm = ({ countries }) => {
    return (
        <Container className="container-form general-container" style={{ marginTop: "0px" }}>
            <div className="row p-1">
                <div className="col-12">
                    <h2 className="title-2 text-bold">Información de contacto</h2>
                    <FillForm countries={countries} />
                </div>
            </div>
        </Container>
    );
};

export default FirstForm;
